import { Link } from "react-router-dom";
import { CONTACT_EMAIL, whatsAppChatUrl } from "../../config/site";

export default function HomeCorporateCta() {
  const quoteUrl = whatsAppChatUrl(
    "Hi Rencin Gifting — I would like a quote for corporate / bulk gift boxes.",
  );

  return (
    <section className="home-corporate" aria-labelledby="home-corporate-heading">
      <div className="home-corporate__inner">
        <p className="lux-eyebrow lux-eyebrow--on-dark">Corporate &amp; bulk</p>
        <h2 id="home-corporate-heading" className="lux-h2 lux-h2--light">
          Gifting for teams, events, and clients
        </h2>
        <p className="home-corporate__lead">
          From branded keepsakes to festive hampers — we help you gift at scale without losing the
          boutique feel. Share your headcount, occasion, and budget.
        </p>
        <div className="home-corporate__actions">
          <a href={quoteUrl} className="lux-btn lux-btn--primary" target="_blank" rel="noopener noreferrer">
            Get a quote on WhatsApp
          </a>
          <Link to="/about" className="lux-btn lux-btn--ghost">
            Contact us
          </Link>
        </div>
        <p className="home-corporate__note">
          Or email{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="home-corporate__email">
            {CONTACT_EMAIL}
          </a>
        </p>
      </div>
    </section>
  );
}
